export const notAccurateLabel = 'It wasn’t accurate';
export const notClearLabel = 'It wasn’t clear';
export const notRelevantLabel = 'It wasn’t relevant';
